module.exports = __webpack_public_path__ + "resources/image_loading_ver.a2eb781e75e91dc1.png";